module.exports = "./src/client/ui/layout/header-brianza/image/ASST_Brianza.svg?2162cf903496c8ee33a3fc994659d3c0";